import { AudioVideoSettingsDialog } from "modules/audioVideo/components/Settings";
import { useSelector } from "react-redux";
import { selectShowCameraSettingsDialog } from "./redux/selectors";

const CameraSettingsContainer = () => {
  const showCameraSettingsDialog = useSelector(selectShowCameraSettingsDialog);

  if (!showCameraSettingsDialog) {
    return null;
  }

  return <AudioVideoSettingsDialog />;
};

export default CameraSettingsContainer;
